import React from 'react';
import { Box, Typography } from '@mui/material';

const LogoSection = ({ 
  onClick, 
  isMobile = false,
  centered = false 
}) => {
  const logoStyle = {
    display: 'flex', 
    alignItems: 'center', 
    gap: 0.5,
    cursor: 'pointer',
    '&:hover': { opacity: 0.8 },
    ...(centered && {
      position: 'absolute',
      left: '50%',
      transform: 'translateX(-50%)'
    })
  };

  const logoSize = isMobile ? 26 : 26;
  const fontSize = isMobile ? 22 : 22;

  return (
    <Box onClick={onClick} sx={logoStyle}>
      <img 
        src="/logo.png" 
        alt="TubeDigest 로고" 
        style={{ 
          width: logoSize, 
          height: logoSize, 
          objectFit: 'contain', 
          borderRadius: 6 
        }} 
      />
      <Typography 
        sx={{ 
          fontWeight: 700, 
          fontSize, 
          color: '#222', 
          letterSpacing: -0.8, 
          fontFamily: 'Roboto, sans-serif' 
        }}
      >
        TubeDigest
      </Typography>
    </Box>
  );
};

export default LogoSection; 